import * as yup from 'yup';
export const companyDetailsInitialValues = {
  name: '',
  postalAddress: '',
  website: '',
  propertyManagementSoftware: '',
  specifySoftware: undefined,
  unitsProjected: ''
};
export const companyDetailsSchema = yup.object({
  name: yup.string().min(2, 'errors.min').required('errors.required'),
  postalAddress: yup.string().min(2, 'errors.min').required('errors.required'),
  // website: yup.string().notRequired(),
  propertyManagementSoftware: yup.string().min(2, 'errors.min').notRequired(),
  unitsProjected: yup.number().positive('errors.only_positive_number').truncate().notRequired()
});